import * as React from "react";
import { cn } from "@/utils";

export interface TextLabelProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
}

function TextLabel({ title, subtitle, className, ...props }: TextLabelProps) {
  return (
    <div
      className={cn("grid flex-1 text-left text-sm leading-tight", className)}
      {...props}
    >
      <span className="truncate font-semibold font-display text-base">
        {title}
      </span>
      {subtitle && <span className="truncate text-xs">{subtitle}</span>}
    </div>
  );
}

export { TextLabel };
